import type { ReactNode } from 'react';

export const symbol_nest_heat_link_gen_3: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M320-120q-83 0-141.5-58.5T120-320v-320q0-83 58.5-141.5T320-840h320q83 0 141.5 58.5T840-640v320q0 83-58.5 141.5T640-120H320Zm0-60h320q58.33 0 99.17-40.83Q780-261.67 780-320v-320q0-58.33-40.83-99.17Q698.33-780 640-780H320q-58.33 0-99.17 40.83Q180-698.33 180-640v320q0 58.33 40.83 99.17Q261.67-180 320-180Zm287.5-152.5Q660-385 660-460t-52.5-127.5Q555-640 480-640t-127.5 52.5Q300-535 300-460t52.5 127.5Q405-280 480-280t127.5-52.5ZM480-340q-50.4 0-85.2-34.8Q360-409.6 360-460q0-50.4 34.8-85.2Q429.6-580 480-580q50.4 0 85.2 34.8Q600-510.4 600-460q0 50.4-34.8 85.2Q530.4-340 480-340Zm.5-340q12.5 0 21-9t8.5-21.5q0-12.5-8.62-21-8.63-8.5-21.38-8.5-12 0-21 8.62-9 8.63-9 21.38 0 12 9 21t21.5 9Zm-.5 220Z"
		/>
	</svg>
);
